<template>
  <CommunicationsManager v-if="initialData" v-bind="initialData" />
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";

import CommunicationsManager from "@/Communications/CommunicationsManager.vue";

const initialData = ref<{
  settingsPath: string;
  changeHistoryPath: string;
  subpage?: boolean;
} | null>(null);

onMounted(async () => {
  const res = await fetch(`${window.location.pathname}/initial_page_data`, {
    method: "GET"
  });
  initialData.value = await res.json();
});
</script>
